function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccMisc = function SvgMccMisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40 23.4v.8l-2 12.2c-.2 1-1 1.6-2 1.6H4c-1 0-1.8-.6-2-1.6l-2-12v-.8c0-.2 0-.4.2-.6l4.6-7.2L2 6.6v-1C2.2 3.6 4 2 6 2h28c2 0 3.8 1.6 4 3.6v1l-2.8 9 4.6 7.2c0 .1.05.2.1.3.05.1.1.2.1.3Zm-8.6-9 2-6.4H6.6l2 6.4h22.8ZM26 23c0-.6.4-1 1-1h7.4l-2.8-4.4H8.4L5.6 22H13c.6 0 1 .4 1 1v7c0 1 1 2 2 2h8c1 0 2-1 2-2v-7Zm-3.4 1.4c0 1-.4 1.8-1.2 2.2l1.4 2.6c.2.4 0 .8-.4.8H18c-.4 0-.6-.4-.4-.8l1.4-2.6c-.8-.6-1.2-1.2-1.2-2.2 0-1.2 1.2-2.4 2.4-2.4s2.4 1 2.4 2.4Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccMisc;